import { render, staticRenderFns } from "./Passenger.vue?vue&type=template&id=23d3e5ec&scoped=true&"
import script from "./Passenger.vue?vue&type=script&lang=js&"
export * from "./Passenger.vue?vue&type=script&lang=js&"
import style0 from "./Passenger.vue?vue&type=style&index=0&id=23d3e5ec&prod&lang=css&"
import style1 from "./Passenger.vue?vue&type=style&index=1&id=23d3e5ec&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d3e5ec",
  null
  
)

export default component.exports